import Layout from '@/layout';
var userRouter = {
  path: '/user',
  component: Layout,
  redirect: '/user/list',
  name: 'user',
  meta: {
    title: '人员管理',
    icon: 'user'
  },
  children: [{
    path: 'list',
    component: function component() {
      return import('@/views/user/list');
    },
    name: 'userList',
    meta: {
      title: '人员管理',
      icon: 'user'
    }
  }]
};
export default userRouter;